import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/useAppStore';
import { CollapsiblePanel } from './CollapsiblePanel';
import { SegmentedToggle } from '../controls/SegmentedToggle';
import { ColorPicker } from '../controls/ColorPicker';
import { TextInput } from '../controls/TextInput';
import './FramePanel.css';

export const FramePanel: React.FC = () => {
  const { t } = useTranslation('create');
  const config = useAppStore(state => state.config);
  const setConfig = useAppStore(state => state.setConfig);

  const frameOptions: { value: 'none' | 'square' | 'rounded', label: string }[] = [
    { value: 'none', label: t('create.frame.none', 'None') },
    { value: 'square', label: t('create.frame.square', 'Square') },
    { value: 'rounded', label: t('create.frame.rounded', 'Rounded') },
  ];

  return (
    <CollapsiblePanel title={t('create.frame.title', 'Frames')} defaultExpanded={false}>
      <SegmentedToggle 
        label={t('create.frame.style', 'Frame Style')}
        options={frameOptions}
        value={config.frameStyle}
        onChange={v => { setConfig({ frameStyle: v }); }}
      />
      
      {config.frameStyle !== 'none' && (
        <>
          <ColorPicker 
            label={t('create.frame.frameColor', 'Frame Color')}
            color={config.frameColor} 
            onChange={c => { setConfig({ frameColor: c }); }} 
          />
          <TextInput
            id="frame-label"
            label={t('create.frame.label', 'Frame Label Text')}
            type="text"
            maxLength={40}
            value={config.frameLabel}
            onChange={e => { setConfig({ frameLabel: e.target.value }); }}
            placeholder={t('create.frame.labelPlaceholder', 'Scan Me')}
          />
          <ColorPicker 
            label={t('create.frame.labelColor', 'Label Color')}
            color={config.frameLabelColor} 
            onChange={c => { setConfig({ frameLabelColor: c }); }} 
          />
        </>
      )}
    </CollapsiblePanel>
  );
};
